module.exports = __webpack_public_path__ + "img/rep-management.2eb02d70.svg";